(function () {
  'use strict';

  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
  var FORM_VERSION = 'pro_v2_2026_08';

  function readStored(key) {
    try {
      return JSON.parse(window.localStorage.getItem(key) || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function currentAttribution() {
    var params = new URLSearchParams(window.location.search);
    var values = {};
    ATTR_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) values[key] = value;
    });
    return values;
  }

  function populated(object) {
    return object && Object.keys(object).some(function (key) { return Boolean(object[key]); });
  }

  function setIfPresent(params, key, value) {
    if (value !== undefined && value !== null && String(value).trim()) {
      params.set(key, String(value).trim());
    }
  }

  function buildApplicationUrl(element) {
    var baseUrl = element.getAttribute('data-pro-application-base-url')
      || element.getAttribute('href')
      || element.getAttribute('src');
    if (!baseUrl) return null;

    var firstTouch = readStored('stackhouse_first_touch');
    var storedApplicationTouch = readStored('stackhouse_utm');
    var directApplicationTouch = currentAttribution();
    var applicationTouch = Object.assign({}, storedApplicationTouch, directApplicationTouch);
    var params = new URL(baseUrl, window.location.origin).searchParams;

    setIfPresent(params, 'application_form_version', FORM_VERSION);
    setIfPresent(params, 'shopify_customer_id', element.getAttribute('data-shopify-customer-id'));

    ATTR_KEYS.forEach(function (key) {
      setIfPresent(params, key, applicationTouch[key]);
      setIfPresent(params, 'application_' + key, applicationTouch[key]);
      setIfPresent(params, 'first_touch_' + key, firstTouch[key]);
    });

    setIfPresent(params, 'landing_page_url', firstTouch.landing_page_url || firstTouch.landingPageUrl);
    setIfPresent(params, 'referrer_url', firstTouch.referrer_url || firstTouch.referrerUrl);
    setIfPresent(
      params,
      'attribution_capture_method',
      populated(directApplicationTouch) ? 'application_url' : (populated(applicationTouch) ? 'theme_local_storage' : 'direct')
    );

    var pageParams = new URLSearchParams(window.location.search);
    setIfPresent(
      params,
      'referral_code',
      pageParams.get('referral_code') || pageParams.get('referral') || pageParams.get('ref')
    );

    var url = new URL(baseUrl, window.location.origin);
    url.search = params.toString();
    return url.toString();
  }

  function hydrateApplicationUrls() {
    document.querySelectorAll('[data-pro-application-url]').forEach(function (element) {
      var hydratedUrl = buildApplicationUrl(element);
      if (!hydratedUrl) return;

      if (element.tagName === 'IFRAME') element.setAttribute('src', hydratedUrl);
      else element.setAttribute('href', hydratedUrl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateApplicationUrls);
  } else {
    hydrateApplicationUrls();
  }
})();
